package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.styles.Motion
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.styleModifier
import kotlinx.browser.document
import kotlin.random.Random

@Composable
fun RevealOnScroll(
    delayMs: Int = 0,
    threshold: Double = 0.15,
    content: @Composable () -> Unit,
) {
    val elementId = remember { "sb-reveal-${Random.nextLong().toString(16)}" }
    var visible by remember { mutableStateOf(false) }

    DisposableEffect(elementId) {
        val target = document.getElementById(elementId)
        if (target == null || visible) {
            onDispose {}
        } else {
            val window = kotlinx.browser.window.asDynamic()
            val callback: (dynamic, dynamic) -> Unit = { entries, obs ->
                val first = entries[0]
                if (first != null && first.isIntersecting == true) {
                    visible = true
                    obs.unobserve(target)
                    obs.disconnect()
                }
            }
            val options = js("({})")
            options.threshold = threshold
            val observer = js("new window.IntersectionObserver(callback, options)")
            observer.observe(target)
            onDispose {
                js("observer.disconnect()")
                Unit
            }
        }
    }

    Box(
        modifier = Modifier
            .id(elementId)
            .fillMaxWidth()
            .let { base ->
                if (visible) {
                    base.classNames(Motion.ENTER_CLASS).styleModifier {
                        property("animation-delay", "${delayMs}ms")
                    }
                } else {
                    base.classNames("sb-reveal-hidden")
                }
            },
    ) {
        content()
    }
}
